import React, { Component } from 'react';
import PropTypes from 'prop-types';
import createMarkup from '@medscape-promo/medscapetv/utils/create-markup';
import VideoPlayer from '@medscape-promo/medscapetv/main/player';
import Breadcrumb from '@medscape-promo/medscapetv/main/breadcrumb';
import PersistentVideoBar from '@medscape-promo/medscapetv/main/persistent-video-bar';
import EpisodeContent from './episode-content';
import VideoSchema from '@medscape-promo/medscapetv/main/video-schema';
class EpisodeTemplate extends Component {
    constructor(props) {
        super(props);
        require('./episode-template.scss');
        //console.log("[EpisodeTemplate] props:", props);
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.path !== this.props.path;
    }
    componentDidUpdate(prevProps) {
        //console.log("[EpisodeTemplate] Updated:", this.props);
    }
    render() {
        //console.log("[EpisodeTemplate] render:",this.props);
        const { location, breadcrumb, summary, episodeNumber, thumbnail, title: episodeTitle, "publish-date": publishDate, episodeTag, video, widgets } = this.props;
        const episodeLabel = episodeTag.trim().length > 0 ? episodeTag : `Episode ${episodeNumber}`;

        const episodeContentProps = {
            episodeLabel,
            widgets,
            episodeTitle,
            publishDate
        }
        const videoSchemaProps = {
            video,
            location,
            summary,
            thumbnail,
            publishDate
        }
        return (
            <section className="template-container episode-template">
                <Breadcrumb {...breadcrumb} />               
                <PersistentVideoBar key="persistent-video-bar" location={location}>
                    <div className="video-section">
                        <VideoSchema key="mtv-video-schema" {...videoSchemaProps} />
                        <VideoPlayer key="mtv-video-player"  config={video} />
                    </div>
                    <div className="details-section">
                        <div className="episode-info">
                            <div className="info-container">
                                <div className="episode-label"><span dangerouslySetInnerHTML={createMarkup(episodeLabel) }></span></div>
                            </div>
                        </div>
                        <div className="episode-title" dangerouslySetInnerHTML={createMarkup(episodeTitle) }></div>
                    </div>
                 </PersistentVideoBar>
                
                <EpisodeContent {...episodeContentProps } />
            </section>
        )
    }

    static get propTypes() {
        return {
            path: PropTypes.string,
            linksTarget: PropTypes.string,
            location: PropTypes.object,
            breadcrumb: PropTypes.object,
            summary: PropTypes.string,
            episodeNumber: PropTypes.string,
            thumbnail: PropTypes.string,
            title: PropTypes.string,
            "publish-date": PropTypes.object,
            episodeTag: PropTypes.string,
            video: PropTypes.object,
            widgets: PropTypes.object,
            imageServer: PropTypes.object
        }
    }

    static get defaultProps() {
        return {
            path: "",
            linksTarget: "",
            location: document.location,
            breadcrumb: {},
            summary: "",
            episodeNumber: "",
            thumbnail: "",
            title: "",
            episodeTag: "",
            video: {},
            widgets: {},
            imageServer: {
                host: ""
            }
        }
    }
}



export default EpisodeTemplate;